// @ts-nocheck
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import { getCookie, setCookie } from "@insite/client-framework/Common/Cookies";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Modal from "@insite/mobius/Modal";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import parse from "html-react-parser";
import React, { useEffect, useState } from "react";
import { css } from "styled-components";

const enum fields {
    popupTitle = "popupTitle",
    popupMessage = "popupMessage",
    buttonVariant = "buttonVariant",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.popupTitle]: string;
        [fields.popupMessage]: string;
        [fields.buttonVariant]: "primary" | "secondary" | "tertiary";
    };
}

type Props = OwnProps;

export interface ScorpionRedirectionAlertStyles {
    modalButton?: ButtonPresentationProps;
    modalMessage?: TypographyPresentationProps;
    buttonWrapper?: InjectableCss;
}

export const scorpionRedirectionAlertStyles: ScorpionRedirectionAlertStyles = {
    modalButton: {
        css: css`
            margin-right: ${pxToRem(20)};
        `,
    },
    modalMessage: {
        variant: "p",
    },
    buttonWrapper: {
        css: css`
            text-align: right;
        `,
    },
};

const styles = scorpionRedirectionAlertStyles;

const ScorpionRedirectionAlert: React.FC<Props> = props => {
    const [isOpen, setIsOpen] = useState(false);

    const cookie = getCookie("_redirection");

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const isRedirectThere = queryParams.has("redirect");
        const hasRequiredValue = queryParams.get("redirect");

        if (isRedirectThere && !cookie && hasRequiredValue === "scorpion") {
            setCookie("_redirection", "true", { expires: 2 });
            setIsOpen(true);
        }
    }, []);

    return (
        <Modal
            isOpen={isOpen}
            handleClose={() => setIsOpen(false)}
            headline={props.fields.popupTitle}
            contentLabel="Redirection Popup"
        >
            <Typography {...styles.modalMessage}>{parse(props.fields.popupMessage, parserOptions)}</Typography>
            <StyledWrapper {...styles.buttonWrapper}>
                <Button {...styles.modalButton} variant={props.fields.buttonVariant} onClick={() => setIsOpen(false)}>
                    Okay
                </Button>
            </StyledWrapper>
        </Modal>
    );
};

const definition: WidgetDefinition = {
    group: "Header",
    fieldDefinitions: [
        {
            name: fields.popupTitle,
            displayName: "Title",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "Translatable",
            tooltip: "Title of the modal to display",
            placeholder: "Popup Title",
            isRequired: true,
        },
        {
            name: fields.popupMessage,
            displayName: "Message",
            editorTemplate: "RichTextField",
            defaultValue: "",
            fieldType: "Translatable",
            tooltip: "Redirection message that will be displayed to the user",
            placeholder: "Popup Message",
            isRequired: true,
        },
        {
            name: fields.buttonVariant,
            displayName: "Button Variant",
            editorTemplate: "DropDownField",
            options: [
                {
                    displayName: "Primary",
                    value: "primary",
                },
                {
                    displayName: "Secondary",
                    value: "secondary",
                },
                {
                    displayName: "Tertiary",
                    value: "tertiary",
                },
            ],
            tooltip: "Different button variants depending on the requirement",
            isRequired: true,
            defaultValue: "",
            fieldType: "Translatable",
        },
    ],
};

const widgetModule: WidgetModule = {
    component: ScorpionRedirectionAlert,
    definition,
};

export default widgetModule;
